module.exports = __webpack_public_path__ + "static/media/3.d018c24d.jpg";